import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import ComponentVesselListTable from './Components';
import { RootState } from '../../../redux/rootState';
import { exportToExcelData } from '../../../Common/PageHeader/helper';

function ScreenVesselList() {
  const { VesselListData } = useSelector((state: RootState) => state.ListVesselReducer);

  const excelData = useMemo(() => VesselListData?.Data?.map((item) => {
    const transformedDataItems = {
      Description: item?.Description,
    };
    return transformedDataItems;
  }), [VesselListData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Vessel_list',
    );
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="VESSEL LIST" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentVesselListTable />
      </Grid>
    </Grid>
  );
}

export default ScreenVesselList;
